import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-common';

interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[]
  }
}

@Injectable({
    providedIn: 'root'
  })
export class RoleGuardService implements CanActivate {

  constructor(private authService: MsalService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole = route.data.expectedRole;
    if (expectedRole != undefined)
    {
      let account: Account = this.authService.instance.getAllAccounts()[0];

      if (account ==undefined)
      {
        return true;
      }

      if (account?.idTokenClaims?.roles  == undefined)
      {
        window.alert('Acceso no autorizado');
        this.router.navigate(['help/notauthorized']);
        return false;
      }

      var rolExist = false;
      expectedRole.forEach((currentValue, index) => {
       if(account.idTokenClaims?.roles.indexOf(currentValue) !== -1)
       {
        return rolExist = true;
       }
      });

      if (rolExist == false)
      {
        window.alert('Acceso no autorizado');
        this.router.navigate(['help/notauthorized']);
        return false;
      }
  }

    return true;
  }
}
